import { render, staticRenderFns } from "./DelIcon.vue?vue&type=template&id=45bdaab5"
import script from "./DelIcon.vue?vue&type=script&lang=js"
export * from "./DelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports